import { CatalogDependenciesObject } from './../../../models/catalog/catalog-dependencies-object.model';
import { isNullOrUndefined } from 'util';
import { Injectable } from '@angular/core';
import { Converter } from './../converter.interface';

@Injectable({
  providedIn: 'root'
})

export class CatalogDependenciesObjectConverter implements Converter<CatalogDependenciesObject> {

  convert(input: any): CatalogDependenciesObject {

    if (isNullOrUndefined(input)) {
      return CatalogDependenciesObject.create();
    }
    return new CatalogDependenciesObject(JSON.stringify(input, null, 2), input.length);

  }

}
